import __request__ from "routing/request";
export function update(news_feed, release_feed, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.customization/welcome", null, { "news_feed": news_feed, "release_feed": release_feed }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
